import styled from 'styled-components';

export const StyledSignInBackground = styled.div`
  width: 100vw;
  height: 100vh;

  img {
    width: 100vw;
    height: 100vh;

    object-fit: cover;
    object-position: center;
  }
`;
